import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getAssemblyList = createAsyncThunk("/get-Assembly-list", async (data, { rejectWithValue }) => {
  // const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}assembly/api/v1/search`, data, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    console.log("API Response:", response);
    return response.data; 
  } catch (error) {
    console.error("Error fetching Assembly List", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Assembly List");
  }
});